import styled from "@emotion/styled"
import { Grid, Typography } from "@material-ui/core"

export const StyledTimeSwitchTitle = styled.span`
  text-transform: capitalize;
  font-weight: 400;
`

export const StyledTimeSwitchSubtitle = styled(Typography)`
  display: block;
  text-align: center;
`

export const StyledGrid = styled(Grid)`
  width: calc(100% + 1rem);
`
